import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { useLocalization } from '../../../localization'
import {
  CBCheckItem,
  CBColorPicker,
  CBInput,
  CBList,
  CBListItem
} from '../../core/components/cbd'

// Removed Select, Space imports
// Added CBSelect import
import { CBSelect } from '../../core/components/CBSelect';
import { useGlobalState } from '../../../store'
import { accountIconMap } from '../../../utils/customIcons'
import { syncFilterText, syncTypeText } from '../../../utils/words'
import ColorPicker from './ColorPicker'
import CompactColorPicker from './CompactColorPicker'

import {ReactComponent as Connections} from '../../../images/svg/connections.svg'

const SyncItemEdit = ({ item, onItemChange, index }) => {
  const { t } = useLocalization();
  const [accounts] = useGlobalState('accounts')
  const [license] = useGlobalState('license')
  
  const findSource = accounts.filter(
    (a) => item.sourceCalendarAccountId === a.calendarAccountId
  )
  
  const sourceAccount =
    findSource.length > 0
      ? findSource[0]
      : item.sourceCalendarType == 'ics'
      ? { email: 'ICS URL' }
      : { email: 'Account missing please add again or contact support' }
  
  const findDest = accounts.filter(
    (a) => item.destCalendarAccountId === a.calendarAccountId
  )
  const destAccount =
    findDest.length > 0
      ? findDest[0]
      : { email: 'Account missing please add again or contact support' }

  if (!sourceAccount || !destAccount) {
    console.log('FAILED')
    return null
  }

  function getTypeIcon(type) {
    if (type == 'ics') {
      return (
        <div className="flex justify-center mt-1">
          <Connections></Connections>
        </div>
      )
    }
    return (
      <FontAwesomeIcon
        icon={accountIconMap[type].icon}
        style={{
          marginLeft: 0,
          marginRight: 0,
          display: 'inline-block',
        }}
      />
    )
  }

  const handleTagChange = (value) => {
    const updatedItem = { ...item, tag: value };
    onItemChange(updatedItem, index);
  };

  const handleColorChange = (color) => {
    const updatedItem = { ...item, destColor: color };
    onItemChange(updatedItem, index);
  };

  const handleMatchColorsChange = (checked) => {
    const updatedItem = { ...item, matchColors: checked };
    onItemChange(updatedItem, index);
  };

  const handleFilterColorChange = (color) => {
    const updatedItem = { ...item, filterColor: color };
    onItemChange(updatedItem, index);
  };

  const handleExcludeInvitesChange = (checked) => {
    const updatedItem = { ...item, excludeInvites: checked };
    onItemChange(updatedItem, index);
  };

  const handleSyncLevelChange = (level, checked) => {
    let newSyncLevel = [...item.syncLevel.split('|')];
    
    if (checked) {
      // Remove the level if it's being unchecked
      newSyncLevel = newSyncLevel.filter(l => l !== level);
    } else {
      // Add the level if it's being checked
      if (!newSyncLevel.includes(level)) {
        newSyncLevel.push(level);
      }
    }
    
    const updatedItem = { ...item, syncLevel: newSyncLevel.join('|') };
    onItemChange(updatedItem, index);
  };

  // getColorOptions returns label/value objects for CBSelect
  const getColorOptions = () => {
    const noneOption = { value: 'none', label: 'None' };
    const msOptions = [
      { value: "Green category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#00ff00' }} /> Green category</div> },
      { value: "Yellow category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2 bg-yellow-200" /> Yellow category</div> },
      { value: "Red category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2 bg-red-500" /> Red category</div> },
      { value: "Orange category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: 'orange' }} /> Orange category</div> },
      { value: "Blue category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: 'blue' }} /> Blue category</div> },
      { value: "Purple category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: 'purple' }} /> Purple category</div> },
    ];
    const googleOptions = [
       { value: "11", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#D50000' }} /> Tomato</div> },
       { value: "10", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#0B8043' }} /> Basil</div> },
       { value: "9", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#3F51B5' }} /> Blueberry</div> },
       // Add other Google colors as needed
    ];

    if (item.destCalendarType === 'ms') { // Use item prop directly
      return [noneOption, ...msOptions];
    } else {
      return [noneOption, ...googleOptions];
    }
  };


  return (
    <>
      <div className="rounded-sm border border-neutral_1 mb-10 flex flex-col shadow-md">
        <div className="flex flex-col pl-4 pr-4">
          {renderSyncLeg(
            getTypeIcon,
            item,
            sourceAccount,
            destAccount,
            'source'
          )}
        </div>
        <div className="pl-4 p-2 flex flex-col justify-center">
          <div className="grid grid-cols-1 gap-4">
            {/* Tag Editor */}
            <div className="border p-4 rounded-md">
              <div className="font-bold mb-2">Tag</div>
              <div className="flex flex-row items-center gap-2">
                <CBInput
                  value={item.tag === 'default' ? '(copy)' : item.tag}
                  onChange={handleTagChange}
                  disabled={item.tag === ' '}
                />
                <CBCheckItem
                  label="No Tag"
                  checked={item.tag === ' '}
                  onChange={(checked) => handleTagChange(checked ? ' ' : '(copy)')}
                />
              </div>
            </div>

            {/* Color Editor */}
            <div className="border p-4 rounded-md">
              <div className="font-bold mb-2">Color</div>
              <div className="flex flex-col gap-2">
                <div className="flex flex-row items-center gap-2">
                  <div className="w-32">Destination Color:</div>
                  <CompactColorPicker
                    type={item.destCalendarType}
                    color={item.destColor}
                    onColorChangeCallback={handleColorChange}
                  />
                </div>
                
                {item.sourceCalendarType === item.destCalendarType && (
                  <CBCheckItem
                    label="Match Source Event Colors"
                    checked={item.matchColors}
                    onChange={handleMatchColorsChange}
                  />
                )}
              </div>
            </div>

            {/* Filters */}
            <div className="border p-4 rounded-md">
              <div className="font-bold mb-2">Filters</div>
              <div className="flex flex-col gap-2">
                <div className="font-semibold">Event Status</div>
                <CBCheckItem
                  label="Exclude Free Events"
                  checked={!item.syncLevel.includes('free')}
                  onChange={(checked) => handleSyncLevelChange('free', !checked)}
                />
                
                {item.sourceCalendarType === 'ms' && (
                  <CBCheckItem
                    label="Exclude Tentative Events"
                    checked={!item.syncLevel.includes('tentative')}
                    onChange={(checked) => handleSyncLevelChange('tentative', !checked)}
                  />
                )}
                
                {item.sourceCalendarType === 'google' && (
                  <CBCheckItem
                    label="Exclude Unaccepted Invites"
                    checked={item.excludeInvites}
                    onChange={handleExcludeInvitesChange}
                  />
                )}
                
                <div className="mt-4 flex flex-row items-center gap-4">
                  <div className="text-base font-semibold">
                    Exclude events with color:
                  </div>
                  {/* Replaced Select with CBSelect */}
                  <CBSelect
                    size="small" // Keep size prop if CBSelect supports it or use className
                    style={{ width: '200px' }} // Keep style for now
                    placeholder="Select a color to filter"
                    selectedValue={item.filterColor}
                    onChange={(val) => handleFilterColorChange(val)} // CBSelect passes index and value
                    labels={getColorOptions().map(opt => opt.label)} // Pass labels array
                    values={getColorOptions().map(opt => opt.value)} // Pass values array
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SyncItemEdit

function renderSyncLeg(
  getTypeIcon,
  item,
  sourceAccount,
  destAccount,
  leg = 'source'
) {
  const sourceAccountType =
    leg == 'source' ? item.sourceCalendarType : item.destCalendarType
  const sourceCalendarName =
    leg == 'source' ? item.sourceCalendarName : item.destCalendarName
  const sourceCalendarEmail =
    leg == 'source' ? sourceAccount.email : destAccount.email
  const destAccountType =
    leg == 'source' ? item.destCalendarType : item.sourceCalendarType
  const destCalendarName =
    leg == 'source' ? item.destCalendarName : item.sourceCalendarName
  const destCalendarEmail =
    leg == 'source' ? destAccount.email : sourceAccount.email
  const destinationColor =
    leg == 'source' ? item.destinationColor : item.sourceColor

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 items-center justify-center justify-items-center p-2">
      <div className="flex flex-col text-center justify-items-center pl-2 ">
        <div className="text-lg gap-2 flex flex-row items-center justify-start">
          <div className="">{getTypeIcon(sourceAccountType)}</div>

          <div className="w-48 truncate text-left ">{sourceCalendarName}</div>
        </div>

        <div className="rounded-full p-2  text-sm">
          {item.sourceCalendarType != 'ics' && (
            <div className="w-40 truncate">{sourceCalendarEmail}</div>
          )}
          {item.sourceCalendarType == 'ics' && (
            <div className="w-40 truncate">
              ...{item.sourceCalendarId.slice(-30)}
            </div>
          )}
        </div>
        <div></div>
      </div>
      
      <div className="flex flex-col justify-center font-manrope text-2xl ml-1 text-center">
        <div>{item.twoWay ? '<-->' : '->'}</div>
      </div>

      <div className="flex flex-col text-center justify-items-center">
        <div className="text-lg gap-2 flex flex-row items-center justify-start">
          <div>{getTypeIcon(destAccountType)}</div>
          <div className="w-48 truncate text-left">{destCalendarName}</div>
        </div>
        <div className="rounded-full p-2  text-sm">
          <div className="w-40 truncate">{destCalendarEmail}</div>
        </div>
        <div></div>
      </div>
    </div>
  )
}
